import { Box, Flex } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

import Image from "components/landing/image"
import { getUrlProps } from "helpers/landing"

const StyledImage = styled(Image).attrs((props) => ({
  containerStyle: { flex: 1 },
  ...props,
}))``

const ImageLink = styled(Link)`
  display: block;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`

const getImageLinkProps = (item, element) => {
  const urlProps = getUrlProps(
    item.url,
    null,
    element.anchor_name || element.id
  )
  return {
    "aria-label": item.image?.alt || item.title,
    ...urlProps,
  }
}

const LandingCollage = ({ element, lazyload }) => {
  const gap = { _: "12px", desktop: 5 }

  return (
    <Box {...element.style}>
      <Flex
        containWide
        flexDirection={{ _: "column", desktop: "row" }}
        gap={gap}
        px={{ _: 2, desktop: "60px" }}
        py={{ _: 3, desktop: "60px" }}
        {...element.container_style}
      >
        <Flex
          flex={{ _: 437 / 607, desktop: 1212 / 1720 }}
          flexDirection="column"
          gap={gap}
        >
          <Flex flex={{ _: 264 / 473, desktop: 822 / 1370 }} gap={gap}>
            <Flex
              flex={{ _: 183 / 331, desktop: 626 / 1172 }}
              position="relative"
            >
              {/* Mobile: top left; Desktop: top left */}
              <ImageLink {...getImageLinkProps(element.data.image1, element)} />
              <StyledImage image={element.data.image1} lazyload={lazyload} />
            </Flex>
            <Flex
              flex={{ _: 148 / 331, desktop: 546 / 1172 }}
              position="relative"
            >
              {/* Mobile: top right; Desktop: top middle */}
              <ImageLink {...getImageLinkProps(element.data.image2, element)} />
              <StyledImage image={element.data.image2} lazyload={lazyload} />
            </Flex>
          </Flex>
          <Flex flex={{ _: 173 / 437, desktop: 548 / 1370 }} gap={gap}>
            <Flex
              flex={{ _: 115 / 331, desktop: 411 / 1172 }}
              position="relative"
            >
              {/* Mobile: middle left; Desktop: bottom left */}
              <ImageLink {...getImageLinkProps(element.data.image3, element)} />
              <StyledImage image={element.data.image3} lazyload={lazyload} />
            </Flex>
            <Flex
              flex={{ _: 216 / 331, desktop: 761 / 1172 }}
              position="relative"
            >
              {/* Mobile: middle right; Desktop: bottom middle */}
              <ImageLink {...getImageLinkProps(element.data.image4, element)} />
              <StyledImage image={element.data.image4} lazyload={lazyload} />
            </Flex>
          </Flex>
        </Flex>
        <Flex
          flex={{ _: 170 / 607, desktop: 548 / 1720 }}
          flexDirection={{ _: "row", desktop: "column" }}
          gap={gap}
        >
          <Flex
            flex={{ _: 161 / 331, desktop: 548 / 1370 }}
            position="relative"
          >
            {/* Mobile: bottom left; Desktop: top right */}
            <ImageLink {...getImageLinkProps(element.data.image5, element)} />
            <StyledImage image={element.data.image5} lazyload={lazyload} />
          </Flex>
          <Flex
            flex={{ _: 170 / 331, desktop: 822 / 1370 }}
            position="relative"
          >
            {/* Mobile: bottom right; Desktop: bottom right */}
            <ImageLink {...getImageLinkProps(element.data.image6, element)} />
            <StyledImage image={element.data.image6} lazyload={lazyload} />
          </Flex>
        </Flex>
      </Flex>
    </Box>
  )
}

LandingCollage.propTypes = {
  element: PropTypes.object,
  lazyload: PropTypes.bool,
}

export default LandingCollage
